import script from "./BrandManagement.vue?vue&type=script&setup=true&lang=js"
export * from "./BrandManagement.vue?vue&type=script&setup=true&lang=js"

import "./BrandManagement.vue?vue&type=style&index=0&id=cebc684c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cebc684c"]])

export default __exports__